import useIsChatOnline from "hooks/useIsChatOnline";

import ChatOfflineWindow from "components/Chat/ChatOfflineWindow";
import ChatUnauthFormWindow from "components/Chat/ChatUnauthFormWindow";

export default function UnauthenticatedUserChat({
  setHideCustomChat,
  connectingToSF,
  setConnectingToSF,
  openChatWindow,
  setOpenChatWindow,
}) {
  const chatOnline = useIsChatOnline(openChatWindow);

  if (!openChatWindow) return <></>;

  if (chatOnline)
    return (
      <ChatUnauthFormWindow
        setHideCustomChat={setHideCustomChat}
        connectingToSF={connectingToSF}
        setConnectingToSF={setConnectingToSF}
        openChatWindow={openChatWindow}
        setOpenChatWindow={setOpenChatWindow}
      />
    );

  return <ChatOfflineWindow setOpenChatWindow={setOpenChatWindow} />;
}
